import axios, { InternalAxiosRequestConfig } from "axios";

import config from "@/config";
import { useAppStore } from "@/store/app";
import { BlogSiteService } from "./BlogSiteService";
import { BlogsListService } from "./BlogsListService";
import { EditorService } from "./EditorService";

const getHeader = () => {
  return {
    channel: "APP",
    source: "WEB_USER",
    version: "2021-07-28",
  };
};

export const requests = (host?: string) => {
  const baseUrl = host || config.REST_API_URLS;
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: getHeader(),
  });

  axiosInstance.interceptors.request.use(async (requestConfig: InternalAxiosRequestConfig) => {
    try {
      const appStore = useAppStore();

      if (requestConfig && requestConfig.headers && appStore.token) {
        (requestConfig.headers as any)["token-id"] = appStore.token;
      }

    } catch (e) {}
    return requestConfig;
  });

  const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  axiosInstance.interceptors.response.use(
    async (response) => {
      try {
        const appStore = useAppStore();
        if (appStore.requestRetryCount !== 0) {
          appStore.updateRequestRetryCount(0);
        }
      } catch (e) {}
      return response;
    },
    async (error) => {
      const appStore = useAppStore();

      if (appStore.requestRetryCount >= 10) {
        appStore.updateRequestRetryCount(0);
        return Promise.reject(error);
      }

      if (error?.config && error?.response && error.response.status === 401) {
        const handshake: any = appStore.appHandshake as any;
        if (handshake && typeof handshake.then === "function") {
          try {
            handshake.then((parent: any) => {
              parent.emit("refresh-token");
            });
          } catch (e) {
            console.warn(e);
          }
        } else {
          console.warn("Handshake unavailable for token refresh");
        }

        await wait(Math.pow(2, appStore.requestRetryCount) * 10);
        appStore.updateRequestRetryCount(appStore.requestRetryCount + 1);
        return axiosInstance.request(error.config);
      }

      return Promise.reject(error);
    }
  );
  return axiosInstance;
};

export { BlogSiteService, BlogsListService, EditorService };
